import { ContextApi } from 'contexts/Localization/types';
import { PageMeta } from './types';

export const DEFAULT_META: PageMeta = {
  title: 'LuckyChip',
  description:
    'LuckyChip is the 1st Web3 Casino with PlaytoEarn and StaketoEarn',
  image: 'https://luckychip.io/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('LuckyChip')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('LuckyChip')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('LuckyChip')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('LuckyChip')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('LuckyChip')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('LuckyChip')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('LuckyChip')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('LuckyChip')}`,
      }
    default:
      return null
  }
}
